/**
 * Dashboard — personal account interactions.
 * Handles free cancellation of bookings.
 */

import {showToast, showConfirm} from "../utils/toast.js";

export function initDashboard() {
    document.addEventListener("click", async (e) => {
        const voucherLink = e.target.closest("[data-dopline-voucher-blob]");
        if (voucherLink) {
            e.preventDefault();
            const url = voucherLink.href;
            const origHtml = voucherLink.innerHTML;
            voucherLink.textContent = "Загружаем…";

            // Open tab synchronously (user gesture) so popup blocker won't fire.
            const win = window.open("", "_blank");
            if (win) {
                win.document.write("<html><body style='margin:0;font-family:sans-serif;padding:20px'>Загружаем ваучер…</body></html>");
            }

            try {
                const resp = await fetch(url, {credentials: "same-origin"});
                const blob = await resp.blob();
                const blobUrl = URL.createObjectURL(blob);
                if (win && !win.closed) {
                    win.document.open();
                    win.document.write(`<!DOCTYPE html><html><head><title>Ваучер</title><style>*{margin:0;padding:0}html,body,embed{width:100%;height:100%}</style></head><body><embed src="${blobUrl}" type="application/pdf"></body></html>`);
                    win.document.close();
                }
            } catch {
                if (win && !win.closed) win.close();
                showToast("Не удалось открыть ваучер.", "error");
            } finally {
                voucherLink.innerHTML = origHtml;
            }
            return;
        }
    });

    document.addEventListener("click", async (e) => {
        const btn = e.target.closest("[data-dopline-cancel-booking]");
        if (!btn) return;

        const billing = btn.dataset.billing || "";
        const hotelName = btn.dataset.hotel || "это бронирование";

        if (!billing) return;

        const confirmed = await showConfirm(
            `Отменить бронирование «${hotelName}»?`,
            "Это действие нельзя отменить.",
            "Отменить бронирование",
            "Назад"
        );
        if (!confirmed) return;

        const CFG = window.DOPLINE_AUTH || {};
        const card = btn.closest(".dopline-dash__booking");
        const origText = btn.textContent.trim();

        btn.disabled = true;
        btn.classList.add("is-loading");
        btn.textContent = "Отменяем…";

        try {
            const body = new URLSearchParams({
                action: "dopline_cancel_booking",
                nonce: CFG.nonce || "",
                billing_number: billing,
            });

            const resp = await fetch(CFG.ajaxUrl || "", {
                method: "POST",
                credentials: "same-origin",
                body,
            });

            const json = await resp.json();

            if (json.success) {
                // Replace cancel button with "Отменено" badge
                btn.remove();

                const aside = card?.querySelector(".dopline-dash__booking-aside");
                if (aside) {
                    const badge = document.createElement("span");
                    badge.className = "dopline-dash__booking-cancelled";
                    badge.textContent = "Отменено";
                    aside.prepend(badge);
                }

                card?.classList.add("dopline-dash__booking--cancelled");
            } else {
                const msg = json.data?.message || "Ошибка при отмене бронирования.";
                showToast(msg, "error");
                btn.disabled = false;
                btn.classList.remove("is-loading");
                btn.textContent = origText;
            }
        } catch {
            showToast("Ошибка сети. Попробуйте ещё раз.", "error");
            btn.disabled = false;
            btn.classList.remove("is-loading");
            btn.textContent = origText;
        }
    });
}
